import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';
import backgroundImage from '../assets/background.jpg'; // Import the background image
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import { motion, useScroll, useTransform } from "framer-motion";

const Contact = () => {
  const { scrollYProgress } = useScroll();

  // Apply transformations based on scroll position for animations
  const mapOpacity = useTransform(scrollYProgress, [0, 0.3], [0, 1]);
  const mapY = useTransform(scrollYProgress, [0, 0.3], [100, 0]);

  const infoOpacity = useTransform(scrollYProgress, [0, 0.4], [0, 1]);
  const infoY = useTransform(scrollYProgress, [0, 0.4], [50, 0]);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Form submitted!');
  };

  return (
    <div>
      {/* Hero Section */}
      <div
        className="flex flex-col items-center justify-center bg-cover bg-center"
        style={{
          backgroundImage: `url(${backgroundImage})`,
          height: '50vh',
        }}
      >
        <div className="flex flex-col items-center justify-center text-center py-10">
          <h6 className="text-xl font-normal text-white">Gravionix technologies</h6>
          <h1 className="text-5xl font-bold text-white">Contact Us</h1>
        </div>

        <div className="mt-8">
          <nav className="flex space-x-6">
            <Link to="/" className="text-lg text-blue-500 hover:text-blue-700">
              Home
            </Link>
            <span className="text-lg text-blue-500">/</span> {/* Dash between links */}
            <Link to="/contact" className="text-lg text-blue-500 hover:text-blue-700">
              Contact
            </Link>
          </nav>
        </div>
      </div>


      {/* Rectangular Blue Box Section */}
      <div className="container mx-auto px-6 py-16">
        <div className="flex flex-col sm:flex-row bg-blue-950 p-6 sm:p-8 rounded-lg shadow-lg text-white space-y-6 sm:space-y-0 sm:space-x-8">
          {/* Left Section: Contact Form */}
          <div className="flex-1 bg-white text-gray-800 p-6 sm:p-8 rounded-lg shadow-lg">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-6">Contact Us</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm sm:text-base font-medium text-gray-700">Full Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full p-4 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Your Full Name"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm sm:text-base font-medium text-gray-700">Email Address</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full p-4 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Your Email"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="block text-sm sm:text-base font-medium text-gray-700">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  rows="5"
                  className="w-full p-4 mt-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Your Message"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-blue-900 text-white p-4 rounded-lg hover:bg-blue-600 transition duration-300"
              >
                Send Message
              </button>
            </form>
          </div>

          {/* Right Section: Contact Info and Social Media */}
          <div className="flex-1 p-6 sm:p-8">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-6">Get a Quote</h2>
            <p className="text-lg sm:text-xl mb-4">We would love to hear about your project. Reach out to us today!</p>

            <div className="space-y-4">
              <div>
                <h3 className="text-lg sm:text-xl font-semibold">Address</h3>
                <p className="text-white  transition duration-300">F038 EXPRESS ZONE MALL, A-WING, NEXT TO PATELVANIKA, W.E.HIGHWAY, GOREGAON EAST MUMBAI 400063</p>
                {/* <p>
    <a href="mailto:info@sigmaitinnovation.in" className="text-white hover:text-blue-700 transition duration-300">
      info@sigmaitinnovation.in
    </a>
  </p> */}
              </div>
              {/* <div>
                <h3 className="text-lg sm:text-xl font-semibold">Phone</h3>
                <p>+1 (555) 123-4567</p>
              </div> */}
            </div>

            {/* Social Media Icons */}
            <div className="flex space-x-4 mt-6 justify-center sm:justify-start">
              <a href="https://facebook.com" className="text-white hover:text-blue-500">
                <FaFacebook size={24} />
              </a>
              <a href="https://twitter.com" className="text-white hover:text-blue-400">
                <FaTwitter size={24} />
              </a>
              <a href="https://linkedin.com" className="text-white hover:text-blue-600">
                <FaLinkedin size={24} />
              </a>
              <a href="https://instagram.com" className="text-white hover:text-blue-500">
                <FaInstagram size={24} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Google Map and Contact Information */}
      <div className="flex flex-col md:flex-row gap-8 justify-center pb-16 md:pb-24 pl-6">
        {/* Google Map Section */}
        <motion.div
          className="w-[90%] sm:w-[85%] md:w-[50%] lg:w-[45%] rounded-lg shadow-xl bg-gray-100 pl-4 pr-4 sm:pl-10 pb-6 sm:pb-8"
          style={{ opacity: mapOpacity, y: mapY }}
          whileInView={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: 100 }}
          transition={{ duration: 1 }}
        >
          <h3 className="text-xl sm:text-2xl font-semibold text-center mb-4 text-blue-800">
            Our Location
          </h3>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.4268224575576!2d72.85584097373939!3d19.17655124881111!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b707374fdf5b%3A0xdb893aa5be338aa0!2sExpress%20Zone%20B%20Wing!5e0!3m2!1sen!2sin!4v1737972581986!5m2!1sen!2sin"
            width="100%"
            height="500"
            style={{ border: '0' }}
            allowFullScreen=""
            loading="lazy"
            title="Google Map Location"
          ></iframe>
        </motion.div>

        {/* Updated Contact Information Section */}
        <motion.div
          className="w-[90%] sm:w-[85%] md:w-[40%] lg:w-[35%] bg-gray-100 p-6 sm:p-8 rounded-xl shadow-lg pl-4 sm:pl-8 pb-6 sm:pb-8"
          style={{ opacity: infoOpacity, y: infoY }}
          whileInView={{ opacity: 1, y: 0 }}
          initial={{ opacity: 0, y: 50 }}
          transition={{ duration: 1 }}
        >
          <h3 className="text-xl sm:text-2xl font-semibold text-center mb-4 text-blue-800">
            How to Reach Us
          </h3>
          <p className="text-base sm:text-lg text-gray-700 mb-4">
            We're here to help! Whether you have a question, need assistance, or want to visit us in person, use the contact details below:
          </p>

          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <FaMapMarkerAlt className="text-2xl text-blue-600 hover:text-blue-900" />
              <p className="text-base sm:text-lg text-blue-950">
                <strong>Address:</strong> F038 EXPRESS ZONE MALL, A-WING, NEXT TO PATELVANIKA, W.E.HIGHWAY, GOREGAON EAST MUMBAI 400063
              </p>
            </div>
            {/* <div className="flex items-center gap-4">
              <FaPhoneAlt className="text-2xl text-blue-600 hover:text-blue-900" />
              <p className="text-base sm:text-lg text-blue-950">
                <strong>Phone:</strong> (123) 456-7890
              </p>
            </div> */}
            <div className="flex items-center gap-4">
              <FaEnvelope className="text-2xl text-blue-600 hover:text-blue-900" />
              <p className="text-base sm:text-lg text-blue-950">
  <strong>Email: </strong> 
  <a href="mailto:info@sigmaitinnovation.in" className=" hover:text-blue-700 transition duration-300">
     info@Gravionix.in
  </a>
</p>
            </div>
            <div className="text-base sm:text-lg text-blue-950">
              <strong>Business Hours:</strong>
              <br />
              Mon-Fri: 9 AM - 6 PM
              {/* <br />
              Sat-Sun: Closed */}
            </div>
          </div>

          <button className="mt-6 sm:mt-8 w-full py-3 bg-blue-900 text-white font-bold rounded-lg hover:bg-blue-700 transition">
            Contact Support
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
